import React, { useState } from 'react';
import { Avatar, Box, styled, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useForm } from 'react-hook-form';
import Button from 'components/Common/Button';
import Input from 'components/Common/Input';
import TelInput from 'components/Common/TelInput';
import { useGetCurrentUser, useUpdateCurrentUser } from 'apis/user/hook';

export default function MyProfileForm() {
  const { data: currentUser } = useGetCurrentUser();
  const { mutateAsync: updateUser, isPending } = useUpdateCurrentUser();
  const { mutateAsync: updateUserImage } = useUpdateCurrentUser(true);
  const { handleSubmit, control } = useForm({
    values: { profile: currentUser }
  });
  const [avatarUrl, setAvatarUrl] = useState<string | null>(currentUser?.avatar_url ? currentUser.avatar_url : null);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setAvatarUrl(URL.createObjectURL(file));
      const formData = new FormData();
      formData.append('profile[avatar]', file);
      await updateUserImage(formData);
    }
  };

  return (
    <Box component='form' onSubmit={handleSubmit((data) => updateUser(data))} sx={{ p: 3 }}>
      <Typography>
        Avatar
        <Typography color='red' component='span' sx={{ display: 'inline' }}>
          *
        </Typography>
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 2, sm: '16px' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          marginTop: '8px'
        }}
      >
        <Avatar
          src={avatarUrl || currentUser?.avatar_url || undefined}
          alt={currentUser?.name ?? 'User Avatar'}
          sx={{ width: 64, height: 64, flexShrink: 0 }}
        />
        <Button component='label' variant='outlined' tabIndex={-1} sx={{ width: { xs: '100%', sm: 'auto' } }}>
          Choose files
          <VisuallyHiddenInput type='file' onChange={handleFileChange} accept='image/*' />
        </Button>
        <Typography variant='body2' color='secondary'>
          accepted formats: .png .jpg
        </Typography>
      </Box>
      <Grid container spacing={2} marginTop={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input name='profile.name' label='Name' control={control} fullWidth />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input
            name='profile.email'
            type='email'
            label='Email address'
            control={control}
            fullWidth
            disabled
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TelInput name='profile.phone_number' label='Phone Number' control={control} defaultCountry='US' fullWidth />
        </Grid>
      </Grid>
      <Box sx={{ marginTop: 3 }}>
        <Button type='submit' isPending={isPending} sx={{ display: 'block', marginLeft: 'auto' }}>
          Save Changes
        </Button>
      </Box>
    </Box>
  );
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});
